import * as React from 'react';
import { userOptions } from './endpoints';
import { SimpleFormComponentProps, ApiToUse } from 'app/infrastructure/simple-form/types';
import { UserDefaultValuesProps } from 'app/area/user-profile/default-values/types';
import { PanelsProps, DefaultValues } from 'app/components/access-panel';
import { ComplexValue } from 'app/types-shared';
import { UserDefaultValues } from 'app/components/access-panel/shared/types';

type AccessPanelExternalProps = {
  formComponent: React.ComponentType<SimpleFormComponentProps>;
};

type AccessPanelProps = UserDefaultValuesProps & AccessPanelExternalProps;

export const AccessPanel = (props: AccessPanelProps) => {
  const { data, editMode, formComponent, formValues, validation, clearValidation, translation,
    role, accessData, updateAccessData, clearValueInStore,
    options, loadOptions
  } = props;

  const panelProps: PanelsProps<UserDefaultValues> = {
    translation,
    formComponent,
    formValues,
    validation,

    endpoints: userOptions,

    readOnly: !editMode,

    data,
    roleSelected: !role.fetching && (!!role && !!role.data
      && (!role.data.defaultValues || role.data.defaultValues.length === 0)) ? false : (!!role.data || role.fetching),
    roleBasedData: role && role.data,

    fetchingRoleBasedData: role ? role.fetching : false,
    accessData,
    personOptionsCodes: undefined,
    options,

    updateAccessData,
    clearValidation,
    clearValueInStore,
    loadOptions,
    displaySelectAll: true
  };

  const isValueFieldsReadOnly = (optionsColection: ComplexValue<number>, caseType: ComplexValue<number>) => {
    return !optionsColection || !caseType;
  };

  return <DefaultValues
    {...panelProps}
    apiToUse={ApiToUse.API}
    isValueFieldsReadOnly={isValueFieldsReadOnly}
    isUserTypeRequired={false}
    readOnly={false}
  />;
};
